// components/CategoryCarousel.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../style/CategoryCarousel.css';

const categories = [
  { id: 'PHONE_yxs5wn', name: 'Mobiles', link: '/category/Mobiles' },
  { id: 'TV_xwd59m', name: 'Televisions', link: '/category/Televisions' },
  { id: 'AC_z8aaxs', name: 'Airconditioner', link: '/category/Airconditioner' },
  { id: 'GYS_pzu6x5', name: 'Geysers', link: '/category/Geysers' },
  { id: 'LAP_sbw6w8', name: 'Laptops', link: '/category/Laptops' },
  { id: 'HEAD_ru5mcy', name: 'Headphones & Earphones', link: '/category/Headphones & Earphones' },
  { id: 'WATER_jbbfjw', name: 'Water purifiers', link: '/category/Water purifiers' },
  { id: 'REF_xdkjfs', name: 'Refrigerators', link: '/category/Refrigerators' },
  { id: 'WM_lom7kj', name: 'Washing machines', link: '/category/Washing machines' },
  { id: 'TAB_p1hbgo', name: 'Tablets', link: '/category/Tablets' },
  { id: 'ACC_xgxvq9', name: 'Wearables', link: '/category/Wearables' },
  { id: 'KIT_khips3', name: 'Kitchen appliances', link: '/category/Kitchen appliances' },
  { id: 'SOUND_fp1vml', name: 'Home theatre & soundbars', link: '/category/Home theatre & soundbars' },
  { id: 'GROOM_wnmbbk', name: 'Grooming', link: '/category/Grooming' },
  { id: 'MICRO_n6e6mr', name: 'Microwaves', link: '/category/Microwaves' },
  { id: 'CAMERA_ngtso8', name: 'Cameras', link: '/category/Cameras' },
  { id: 'COOL_ufpiv6', name: 'Cooler', link: '/category/Cooler' },
];

const CDN_BASE = "https://cdn.greateastern.in/GETCO/CATEGORY+ICON";

const CategoryCarousel = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 8;
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setStartIndex((prev) => (prev + 1) % categories.length);
  };

  const prevSlide = () => {
    setStartIndex((prev) => (prev - 1 + categories.length) % categories.length);
  };

  useEffect(() => {
    intervalRef.current = setInterval(nextSlide, 3000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const visibleCategories = [];
  for (let i = 0; i < visibleCount; i++) {
    visibleCategories.push(categories[(startIndex + i) % categories.length]);
  }

  return (
    <div className="category-carousel-wrapper">
      <button className="category-arrow left" onClick={prevSlide}>‹</button>

      <div className="category-carousel">
        {visibleCategories.map((cat, idx) => (
          <Link to={cat.link} key={idx} className="category-card">
            <div className="category-icon">
              <img
                src={`${CDN_BASE}/${cat.id}.png`}
                alt={cat.name}
                className="category-image"
                loading="lazy"
              />
            </div>
            <p className="category-name">{cat.name}</p>
          </Link>
        ))}
      </div>

      <button className="category-arrow right" onClick={nextSlide}>›</button>
    </div>
  );
};

export default CategoryCarousel;
